import DEFAULT_SWITCH_CLASS_NAME from '../../constants/switch';
import FingoMuiSwitch from '../../fingo/components/MuiSwitch';

const defaultSwitch = ({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.gray.A300,
        opacity: 1,
      },
    },
  },
});

const MuiSwitch = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiSwitch.styleOverrides.root({ theme }),
      [`&.${DEFAULT_SWITCH_CLASS_NAME}`]: defaultSwitch({ theme }),
    }),
  },
};

export default MuiSwitch;
